module.exports = __webpack_public_path__ + "static/media/eye-dropper-white.c26b9de2.svg";